// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Yu-z","summaryPar":"Zu-z","ratingCategories":"_u-z","reviewerInfo":"av-z","reviewTypes":"bv-z","expanded":"cv-z"};